var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('container-page',{staticClass:"mb-3"},[_c('bloc-simple',{staticClass:"flex-shrink-0 mb-2",style:(_vm.styleLeftBarLg)},[_c('left-bar')],1),_c('div',{ref:"rightColumn",staticClass:"mt-3 mt-lg-0 w-100"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }